<template>
<div class="chapter">
<div class="inner_page">
<table class="chap">
<colgroup>
<col width="26%"/>
<col width="8%"/>
<col width="66%"/>
</colgroup>
<tbody><tr>
<td align="right" valign="top"><p class="partn"><a id="page_13"></a><em>Part One</em></p></td>
<td> <img alt="image" src="html/images/line.jpg"/></td>
<td valign="bottom"><p class="partc"> <br/> <br/>I<span class="small">F THE</span> M<span class="small">ANTLE</span> F<span class="small">ITS</span> . . .</p></td>
</tr>
</tbody></table>
<p class="imagep" id="page_14"><img alt="Image" src="html/images/f0014-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292734746_10_pt01.vue?aa59c84e